import { NgModule } from '@angular/core';

import { DeviceAuthenticationApiService } from '../api';

import { SysApiDeviceAuthenticationApiService } from './sys-api-device-authentication-api.service';

@NgModule({
	providers: [
		SysApiDeviceAuthenticationApiService,
		{
			provide: DeviceAuthenticationApiService,
			useExisting: SysApiDeviceAuthenticationApiService
		}
	]
})
export class SysApiDeviceAuthenticationDataAccessModule {}
